export default __webpack_public_path__ + "static/media/50t.5b1419e5.jpg";